import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSectionContent = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 37.378 25.214",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Innholdsseksjon",
		transform: "translate(-549.941 -317.574)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "view_comfy_FILL1_wght300_GRAD0_opsz48",
				d: "M100,282.639V276h37.378v6.638Z",
				transform: "translate(449.94 41.573)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "view_comfy_FILL1_wght300_GRAD0_opsz48-2",
				"data-name": "view_comfy_FILL1_wght300_GRAD0_opsz48",
				d: "M100,282.639V276h37.378v6.638Z",
				transform: "translate(449.94 50.861)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "view_comfy_FILL1_wght300_GRAD0_opsz48-3",
				"data-name": "view_comfy_FILL1_wght300_GRAD0_opsz48",
				d: "M100,282.639V276h37.378v6.638Z",
				transform: "translate(449.94 60.149)"
			})
		]
	})
});
export default SvgSectionContent;
